module.exports = function ($bar, width) {
    if (!$bar.length) {
        return;
    }

    $bar.find('.progress-bar__bar').css({
        'width': width
    });
};